var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrid9(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3384_8174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2H3C2.175 2 1.5 2.675 1.5 3.5V15.5C1.5 16.325 2.175 17 3 17H15C15.825 17 16.5 16.325 16.5 15.5V3.5C16.5 2.675 15.825 2 15 2ZM6 15.5H3V12.5H6V15.5ZM6 11H3V8H6V11ZM6 6.5H3V3.5H6V6.5ZM10.5 15.5H7.5V12.5H10.5V15.5ZM10.5 11H7.5V8H10.5V11ZM10.5 6.5H7.5V3.5H10.5V6.5ZM15 15.5H12V12.5H15V15.5ZM15 11H12V8H15V11ZM15 6.5H12V3.5H15V6.5Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3384_8174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid9);
export default __webpack_public_path__ + "static/media/grid-9.f753ec86b97893cd2e53fd7c2946281f.svg";
export { ForwardRef as ReactComponent };